import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { processSteps } from '../../data/features';
import { container } from '../../utils/styles';
import { SectionHeading } from './SectionHeading';
export function ProcessSteps() {
  const {
    t
  } = useLanguage();
  return <section id="how-it-works" className="scroll-mt-36 bg-cream py-20 sm:py-24" aria-labelledby="process-heading" data-id="element-400" data-mp="3ixgb89mfk2xq">
      <div className={container} data-id="element-401" data-mp="2v8x43xf49w78">
        <SectionHeading id="process-heading" align="center" title={t({
        en: 'How It Works',
        es: 'Cómo Funciona'
      })} intro={t({
        en: 'Getting started is simple. Three steps from first call to first visit.',
        es: 'Empezar es sencillo. Tres pasos desde la primera llamada hasta la primera visita.'
      })} data-id="element-402" data-mp="2q8iy0kx2swbu" />
        <ol className="mx-auto mt-14 grid max-w-5xl gap-4 lg:grid-cols-3 lg:gap-16" data-id="element-403" data-mp="fg7xo1yqjp8t">
          {processSteps.map((step, i) => {
          const Icon = step.icon;
          const last = i === processSteps.length - 1;
          return <li key={step.id} className="relative flex flex-col items-center text-center" data-id="element-404" data-mp="2nlzjins5ghjt" data-mpi={i}>
                <div className="relative" data-id="element-405" data-mp="2rq7c4w1qahnb">
                  <span className="flex h-20 w-20 items-center justify-center rounded-full bg-brand text-white" data-id="element-406" data-mp="2rn31bftrcnno">
                    <Icon className="h-9 w-9" aria-hidden="true" data-id="element-407" data-mp="1zxzvhvm8358x" />
                  </span>
                  <span className="absolute -right-1 -top-1 flex h-8 w-8 items-center justify-center rounded-full border-2 border-cream bg-gold font-display font-bold text-brand-deeper" data-id="element-408" data-mp="23zbcxduy0k61">
                    {i + 1}
                  </span>
                </div>
                <h3 className="mt-6 text-2xl font-bold text-ink" data-id="element-409" data-mp="2dqpgpxtxg64z">
                  <span className="sr-only" data-id="element-410" data-mp="1gaipk5sdzkn1">{t({
                  en: 'Step',
                  es: 'Paso'
                })} {i + 1}: </span>
                  {t(step.title)}
                </h3>
                <p className="mt-3 max-w-sm leading-relaxed text-ink-soft" data-id="element-411" data-mp="1l70nalpauipv">{t(step.body)}</p>
                {!last && <>
                    <ArrowRightIcon className="absolute -right-12 top-7 hidden h-7 w-7 text-gold-dark lg:block" aria-hidden="true" data-id="element-412" data-mp="2jl6agg98tdck" />
                    <ArrowDownIcon className="mt-6 h-7 w-7 text-gold-dark lg:hidden" aria-hidden="true" data-id="element-413" data-mp="2xbjh8faeem0b" />
                  </>}
              </li>;
        })}
        </ol>
      </div>
    </section>;
}